import React, { Component } from 'react'
import { Switch } from 'react-router-dom'

import View from 'react-flexbox'
export default class ViewerRoutes extends Component {
    render() {
        const { rotas } = this.props;

        return (
            <View style={{ flex:1, overflow: 'auto' }}>
                <Switch>
                    {rotas}
                </Switch>
            </View>
        )
    }
}





// WEBPACK FOOTER //
// ./src/App/components/ViewerRoutes/ViewerRoutes.js